export const MODULE_NAME = 'user';

const prefix = `${MODULE_NAME}/`;

export const ACTION_TYPES = {
    FINGERPRINT_INITIALIZED: `${prefix}FINGERPRINT_INITIALIZED`,
    INITIALIZE: `${prefix}INITIALIZE`
};
